
export default class CollectionFilter {
  constructor () {
    this.wrapper = document.getElementById('collection-filter')
    this._filterButtons = document.querySelectorAll('.collection-filter')
    this.collection = undefined
  }

  static get EVENT () {
    return {
      CHANGE: 'poin:collectionFilter:change'
    }
  }

  async init () {
    this._filterButtons.forEach(element => element.addEventListener('click', async () => {
      this.collection = element.dataset.collection
      await this.change()
      element.classList.add('selected')
    }))
  }

  async change () {
    this._filterButtons.forEach(element => element.classList.remove('selected'))
    this.wrapper.dispatchEvent(new CustomEvent(CollectionFilter.EVENT.CHANGE, {
      bubbles: true,
      detail: { collection: this.collection }
    }))
  }

  filterIsSet () {
    return this.collection !== undefined
  }
}
